import {FC, useEffect, useState} from "react";
import {AiOutlineExclamation, AiOutlineInfoCircle, AiOutlineWarning} from "react-icons/ai";

interface Props {
  severity: 'warning'|'error'|'info'
  visible?: boolean;
}

const AlertMessage: FC<Props> = (props) => {
  const [background, setBackground] = useState('bg-orange-600');
  const [icon, setIcon] = useState(<AiOutlineWarning className='text-2xl'/>);

  useEffect(() => {
    switch (props.severity) {
      case "warning":
        setIcon(<AiOutlineWarning className='text-2xl'/>);
        setBackground('dark:bg-orange-700 bg-orange-600');
        break;
      case "error":
        setIcon(<AiOutlineExclamation className='text-2xl'/>);
        setBackground('bg-gradient-to-bl from-error-brighter to-error-default');
        break;
      case "info":
        setIcon(<AiOutlineInfoCircle className='text-2xl'/>);
        setBackground('bg-gradient-to-bl from-primary to-secondary');
    }
  },[props.severity])

  return (
    <div className={`${background} text-white p-4 rounded-md border dark:border-black/20 border-white/20 flex items-center space-x-2 ${props.visible === false ? 'hidden' : ''}`}>
      {icon}
      <p className='flex-1 text-sm font-thin'>
        {props.children}
      </p>
    </div>
  );
};

export default AlertMessage;